<template>
    <div class="container-fluid">
        <form @submit.prevent="getData()" >
            <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Pejabat</label>
                        <select class="form-select" v-model="selected.office">
                            <option value="0" selected disabled>Pilih Pejabat</option>
                            <option v-for="office in officeList" :value="office.KodPejabat">{{office.NamaPejabat}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Pegawai</label>
                        <select class="form-select" v-model="selected.officer">
                            <option value="0" selected disabled>Pilih Pegawai</option>
                            <option v-for="officer in officerList" :value="officer.KodPegawai">{{officer.Nama}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Daerah Pewakaf</label>
                        <select class="form-select" v-model="selected.district">
                            <option value="0" selected disabled>Pilih Daerah</option>
                            <option v-for="district in distictList" :value="district.KodDaerah">{{district.daerah}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Bentuk Bayar</label>
                        <select class="form-select" v-model="selected.payType">
                            <option value="0" selected disabled>Pilih Bentuk Bayar</option>
                            <option v-for="type in paymentType" :value="type.ID">{{type.nama}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Bank</label>
                        <select class="form-select" v-model="selected.bank">
                            <option value="0" selected disabled>Pilih Bank</option>
                            <option v-for="bank in bankList" :value="bank.ID">{{bank.NamaBank}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Tarikh Mula</label>
                        <VueDatePicker v-model="selected.start" :auto-position="true"
                                       :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                       placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" class="d-inline-block me-2 w-100"></VueDatePicker>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Tarikh Akhir</label>
                        <VueDatePicker v-model="selected.end" :auto-position="true"
                                       :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                       placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" class="d-inline-block me-2 w-100"></VueDatePicker>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Bilangan per muka</label>
                        <select v-model="selected.pagePerView" class="form-select">
                            <option v-for="page in numberPerPage" :value="page">{{page}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Amaun Minimum (RM)</label>
                        <input type="number" class="form-control" v-model="selected.min" placeholder="0">
                        <div class="form-text">Nombor bulat sahaja.</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Amaun Maksimum (RM)</label>
                        <input type="number" class="form-control" v-model="selected.max" placeholder="0">
                        <div class="form-text">Nombor bulat sahaja.</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Nombor Rujukan Bank</label>
                        <input type="text" class="form-control" v-model="selected.noRujukanBank" placeholder="Nombor Rujukan Bank">
                        <div class="form-text">Masukkan dengan tepat.</div>
                    </div>
                </div>
                <div v-if="kodBank.length > 0 && selected.displayKodBank" class="col-md-3">
                    <div class="mb-3">
                        <label class="label">Kod Bank</label>
                        <multiselect selectedLabel="Sedang dipilih" selectLabel="Tekan untuk pilih" deselectLabel="Tekan untuk buang" placeholder="Sila pilih" :disabled="selected.isDisabledKodBank" :custom-label="optionsLabel" v-model="selected.kodBank" :options="kodBank">
                            <template #noResult>
                                <span>Tiada yang sepadan.</span>
                            </template>
                            <template #noOptions>
                                <span>Kod bank tiada senarai.</span>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-3">
                    <div class="mb-3">
                        <label class="label">Senarai kolum yang dipaparkan</label>
                        <multiselect selectedLabel="Sedang dipilih" selectLabel="Tekan untuk pilih" deselectLabel="Tekan untuk buang" placeholder="Sila pilih" :custom-label="optionsColumsLabel" v-model="selected.columnsDisplay" track-by="value" :multiple="true" :options="columnOpts" :close-on-select="false" >
                            <template #noResult>
                                <span>Tiada yang sepadan.</span>
                            </template>
                            <template #noOptions>
                                <span>Kod bank tiada senarai.</span>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="flex justify-content-center">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="amountAsc" name="amountAscDesc" value="forward" v-model="selected.amounAscDesc" @click="changeSort(($event.target as HTMLInputElement).value)">
                    <label class="form-check-label" for="amountAsc">Susun daripada amaun paling tinggi</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="amountDesc" name="amountAscDesc" value="reverse" v-model="selected.amounAscDesc" @click="changeSort(($event.target as HTMLInputElement).value)">
                    <label class="form-check-label" for="amountDesc">Susun daripada amaun paling rendah</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="showKodBank" v-model="selected.displayKodBank" @click="getKodBank(selected.bank)">
                    <label class="form-check-label" for="showKodBank">Papar kod bank</label>
                </div>
                <form v-if="payerList !== undefined && payerList.length > 0 && kodPegawai !== ''" :action="uri_get_transactions" method="post" class="d-inline-block">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" name="wantExcel" value="1">
                    <input v-if="selected.amounAscDesc !== ''" type="hidden" name="amounAscDesc" :value="selected.amounAscDesc">
                    <input v-if="selected.bank !== 0" type="hidden" name="bank" :value="selected.bank">
                    <input v-if="selected.payType !== 0" type="hidden" name="bentukBayar" :value="selected.payType">
                    <input v-if="selected.district !== 0" type="hidden" name="daerah" :value="selected.district">
                    <input v-if="selected.start !== null" type="hidden" name="date_start" :value="parseDateData(selected.start)">
                    <input v-if="selected.end !== null" type="hidden" name="date_end" :value="parseDateData(selected.end)">
                    <input v-if="selected.min !== null" type="hidden" name="min" :value="selected.min">
                    <input v-if="selected.max !== null" type="hidden" name="max" :value="selected.max">
                    <input v-if="selected.officer !== 0" type="hidden" name="pegawai" :value="selected.officer">
                    <input v-if="selected.office !== 0" type="hidden" name="pejabat" :value="selected.office">
                    <input type="hidden" name="colsarg" :value="excelDownloadColumnDisplay()">
                    <input v-if="selected.kodBank !== null" type="hidden" name="idKodBank" :value="selected.kodBank?.id">
                    <button type="submit" class="btn btn-outline-success fs-6 d-inline-block" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
                </form>
            </div>
            <div class="d-flex justify-content-center">
                <div class="btn-group" >
                    <button type="button" class="btn btn-warning mt-4"
                            @click="goBack">
                        <font-awesome-icon :icon="faChevronLeft" /> Kembali
                    </button>
                    <button type="button" class="btn btn-danger mt-4"
                            @click="resetSearch">
                        <font-awesome-icon :icon="faRotate" /> Reset Carian
                    </button>
                    <button type="submit" class="btn btn-primary mt-4"><font-awesome-icon :icon="faMagnifyingGlass" /> Cari</button>
                </div>
            </div>
        </form>
        <div class="d-md-flex justify-content-end mt-4 overflow-x-auto">
            <nav class="d-inline-block">
                <ul class="pagination" v-if="paginator !== undefined && payerList?.length !== 0">
                    <li class="page-item disabled" v-if="paginator.current_page === 1">
                        <span class="page-link">...</span>
                    </li>
                    <li class="page-item" v-if="paginator.current_page !== 1">
                        <span class="page-link" role="button" @click="getData(paginator.prev_page_url)">Sebelum</span>
                    </li>
                    <template v-for="(page, index) in paginator.links">
                        <li class="page-item" v-if="page.url !== null && !page.active && index !== 0 && index !== Object.keys(paginator.links).length-1">
                            <span class="page-link" role="button" @click="getData(page.url)">{{ page.label }}</span>
                        </li>
                        <li class="page-item active" v-if="page.active">
                            <span class="page-link">{{ page.label }}</span>
                        </li>
                    </template>
                    <li class="page-item" v-if="paginator.current_page !== paginator.last_page">
                        <a class="page-link" role="button" @click="getData(paginator.next_page_url)">Seterusnya</a>
                    </li>
                    <li class="page-item disabled" v-if="paginator.current_page === paginator.last_page">
                        <span class="page-link">...</span>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
    <div class="container-fluid">
        <div class="col">
            <div class="table-responsive" v-if="payerList !== undefined && payerList.length > 0">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">No Kad Pengenalan</th>
                        <th scope="col">Nama</th>
                        <th v-if="payerList[0].NoTel !== undefined" scope="col">Nombor telefon</th>
                        <th v-if="payerList[0].District !== undefined" scope="col">Daerah pewakaf</th>
                        <th v-if="payerList[0].Email !== undefined" scope="col">E-mel</th>
                        <th v-if="payerList[0].ReceiptID !== undefined" scope="col">No Resit</th>
                        <th v-if="payerList[0].RujukanBank !== undefined" scope="col">No Rujukan Bank</th>
                        <th v-if="payerList[0].GrandSum !== undefined" scope="col">Jumlah wakaf (RM)</th>
                        <th v-if="payerList[0].TransactionNum !== undefined" scope="col">Bil Transaksi</th>
                        <th v-if="payerList[0].PayType !== undefined" scope="col">Bentuk bayar</th>
                        <th v-if="payerList[0].RazerID !== undefined" scope="col">Razer</th>
                        <th v-if="payerList[0].BankerName !== undefined" scope="col">Bank</th>
                        <th v-if="payerList[0].Record !== undefined" scope="col">Catatan</th>
                        <th v-if="payerList[0].OffID !== undefined" scope="col">Kod Pegawai</th>
                        <th v-if="payerList[0].PayDate !== undefined" scope="col">Tarikh bayar</th>
                        <th v-if="payerList[0].OfficeID !== undefined" scope="col">Kod Pejabat</th>
                        <th v-if="payerList[0].KodBankKod !== undefined || payerList[0].KodBankKeterangan !== undefined" scope="col">Kod bank</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(payer,index) in payerList">
                        <th scope="row">{{ ((paginator!.current_page-1) * selected.pagePerView)+index+1 }}</th>
                        <td class="text-nowrap">{{ payer.IDNum }}</td>
                        <td>{{ payer.NAME }}</td>
                        <td v-if="payer.NoTel !== undefined">{{ payer.NoTel }}</td>
                        <td v-if="payer.District !== undefined">{{ payer.District }}</td>
                        <td v-if="payer.Email !== undefined">{{ payer.Email }}</td>
                        <td v-if="payer.ReceiptID !== undefined">{{ payer.ReceiptID }}</td>
                        <td v-if="payer.RujukanBank !== undefined" class="text-end whitespace-nowrap overflow-hidden" style="text-overflow: ellipsis; max-width: 4px "><i v-if="payer.RujukanBank === '0'">Tidak berkaitan</i> <span v-else-if="true">{{ payer.RujukanBank  }}</span></td>
                        <td v-if="payer.GrandSum !== undefined" class="text-end">{{ sumFormatWithoutCurrency(payer.GrandSum) }}</td>
                        <td v-if="payer.TransactionNum !== undefined" class="text-center"><a class="btn btn-outline-wakaf-primary" @click="displayPewakafInfo(payer.RID!,payer.NAME,payer.District!)">{{ payer.TransactionNum }}</a></td>
                        <td v-if="payer.PayType !== undefined">{{ payer.PayType }}</td>
                        <td v-if="payer.RazerID !== undefined" class="text-end"> <i v-if="(payer.RazerID === '0')">Tidak berkaitan</i> <span v-else>{{ payer.RazerID }}</span> </td>
                        <td v-if="payer.BankerName !== undefined">{{ payer.BankerName  }}</td>
                        <td v-if="payer.Record !== undefined">{{ payer.Record }}</td>
                        <td v-if="payer.OffID !== undefined" class="text-center">{{ payer.OffID }}</td>
                        <td v-if="payer.PayDate !== undefined">{{ format(parseISO(payer.PayDate),"dd-MM-yyyy HH:mm:ss")  }}</td>
                        <td v-if="payer.OfficeID !== undefined" class="text-center">{{ payer.OfficeID }}</td>
                        <td v-if="payer.KodBankKeterangan !== undefined && payer.KodBankKod !== undefined">{{ ((payer.KodBankKod !== null)?payer.KodBankKod: "Tiada data") + "-" +((payer.KodBankKeterangan !== null)?payer.KodBankKeterangan:"Tiada data") }}</td>
                        <td v-else-if="payer.KodBankKod !== undefined">{{ payer.KodBankKod?? "Tiada data" }}</td>
                        <td v-else-if="payer.KodBankKeterangan !== undefined">{{ payer.KodBankKeterangan?? "Tiada data" }}</td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="payerList[0].GrandSum !== undefined" class="fs-6">Jumlah muka ini : <span class="fw-bold">{{ sumFormat(sumAmountCurrrentPage) }}</span></p>
                <p class="fs-6">Jumlah keseluruhan : <span class="fw-bold">{{ sumFormat(grandSum) }}</span></p>
            </div>
            <div v-if="!isStarting && payerList?.length === 0" class="alert alert-danger">
                <p class="fs-5 text-center"><font-awesome-icon  :icon="faTriangleExclamation" /> Tiada rekod ditemui berdasarkan pilihan dibuat <font-awesome-icon  :icon="faFaceSadTear" /> </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref, onMounted, Ref} from "vue";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { ms }  from "date-fns/locale";
import { format, parseISO} from "date-fns";
import {sumFormat, sumFormatWithoutCurrency, parseDateData} from "../../utils/utils";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faRotate, faMagnifyingGlass, faTriangleExclamation, faFaceSadTear, faFileExcel} from "@fortawesome/free-solid-svg-icons";
import Multiselect from "vue-multiselect";
library.add(faChevronLeft,faRotate, faMagnifyingGlass, faTriangleExclamation, faFaceSadTear);

const officeList: Ref = ref<{
    KodPejabat: number,
    NamaPejabat: string
}[]>();
const officerList: Ref = ref<{
    KodPegawai: number,
    Nama: string
}[]>();
const distictList: Ref = ref<{
    KodDaerah: number,
    daerah: string,
}[]>();
const paymentType: Ref =  ref<{
    ID: number,
    nama: string
}[]>();
const numberPerPage : number[] = [15,30,50,100,300,500];
let isCloseLoader : boolean = false;
const isStarting: Ref = ref<boolean>(true);
const bankList: Ref =  ref<[{
    ID: number,
    NamaBank: string
}]>();
const payerList = ref<{
    BankerID?: number | undefined,
    BankerName?: string | undefined,
    District?: number | undefined,
    Email?: string | undefined,
    NoTel?: string | undefined,
    DistrictID?: number | undefined,
    GrandSum?: number | undefined,
    IDNum: string,
    KodBankKeterangan?: string | undefined,
    KodBankKod?: string | undefined,
    NAME: string,
    OffID?: string | undefined,
    OfficeID?: number | undefined,
    PayDate?: string | undefined,
    PayType?: string | undefined,
    RID?: number | undefined,
    RazerID?: string | undefined,
    ReceiptID?: number | undefined,
    Record?: string | undefined,
    RujukanBank?: string | undefined,
    TransactionNum?: number | undefined,
}[]>();
const paginator: Ref = ref<{
        current_page: number,
        data: {
            BankerID?: number | undefined,
            BankerName?: string | undefined,
            District?: string | undefined,
            Email?: string | undefined,
            NoTel?: string | undefined,
            DistrictID?: number | undefined,
            GrandSum?: number | undefined,
            IDNum: string,
            KodBankKeterangan?: string | undefined,
            KodBankKod?: string | undefined,
            NAME: string,
            OffID?: string | undefined,
            OfficeID?: number | undefined,
            PayDate?: string | undefined,
            PayType?: string | undefined,
            RID?: number | undefined,
            RazerID?: string | undefined,
            ReceiptID?: number | undefined,
            Record?: string | undefined,
            RujukanBank?: string | undefined,
            TransactionNum?: number | undefined,
        }[],
        first_page_url: string,
        from: number,
        last_page: number,
        last_page_url: string,
        links:[{
            active: boolean,
            label: string,
            url: string,
        }],
        next_page_url: string,
        path: string,
        per_page: number,
        prev_page_url: string,
        to: number,
        total: number
}>();

const sumAmountCurrrentPage: Ref = ref<number>(0);
const grandSum: Ref = ref<number>(0);

const data = defineProps<{
    uri_get_transactions: string,
    uri_get_modal: string,
    uri_kodbank: string,
    csrf: string,
    kodPegawai: string,
}>();

const selected = ref<{
    office: number,
    officer: number,
    district: number,
    payType: number,
    bank: number,
    displayKodBank: boolean,
    kodBank: {id: number, kod: string, keterangan: string} | null,
    columnsDisplay: {label: string, value: string, $isDisabled: boolean} [] ,
    isDisabledKodBank: boolean,
    start: string | null,
    end: string| null,
    min: number | null,
    max: number | null,
    amounAscDesc: string,
    noRujukanBank: string,
    pagePerView: number,
}>({
    office: 0,
    officer: 0,
    district: 0,
    payType: 0,
    bank: 0,
    kodBank: null,
    columnsDisplay: [
        {label: "Nama", value: "name", $isDisabled: true},
        {label: "No Kad Pengenalan", value: "noic", $isDisabled: true},
        {label: "Daerah pewakaf", value: "daerahpewakaf", $isDisabled: false},
        {label: "No Resit", value: "noresit", $isDisabled: false},
        {label: "Jumlah keseluruhan", value: "grandsum", $isDisabled: false},
        {label: "Bilangan transaksi", value: "biltransaksi", $isDisabled: false},
        {label: "ID Pegawai", value: "officerid", $isDisabled: false},
        {label: "Tarikh Bayar", value: "tarikhbayar", $isDisabled: false},
    ],
    displayKodBank: false,
    isDisabledKodBank: false,
    start: null,
    end: null,
    min: null,
    max: null,
    noRujukanBank: "",
    amounAscDesc: "",
    pagePerView: 15,
});

const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "showModal", modalData: {
        nama: string,
        daerah: number,
        printLink: string,
        transaction: {
            jenisWakaf : string,
            daerah : number,
            namaProjek : string,
            unit : number,
            jenisPemilikan : string,
            pemilikWakaf : string,
        }[]
    } ): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>();

const kodBank = ref<{
    id: number,
    kod: string,
    keterangan: string,
}[]>([]);
const optionsLabel = (name: { id: number, kod: string, keterangan: string }): string => `${name.kod} - ${name.keterangan}`;

const columnOpts = ref<{label: string, value: string, $isDisabled: boolean}[]>([
    {label: "Nama", value: "name", $isDisabled: true},
    {label: "No Kad Pengenalan", value: "noic", $isDisabled: true},
    {label: "No Tel", value: "notel", $isDisabled: false},
    {label: "Daerah pewakaf", value: "daerahpewakaf", $isDisabled: false},
    {label: "E-mel", value: "email", $isDisabled: false},
    {label: "No Resit", value: "noresit", $isDisabled: false},
    {label: "No Rujukan Bank", value: "rujukanbank", $isDisabled: false},
    {label: "Jumlah keseluruhan", value: "grandsum", $isDisabled: false},
    {label: "Bilangan transaksi", value: "biltransaksi", $isDisabled: false},
    {label: "Bentuk Bayar", value: "bentukbayarnama", $isDisabled: false},
    {label: "No Razer", value: "razerid", $isDisabled: false},
    {label: "Nama Bank", value: "namabank", $isDisabled: false},
    {label: "Catatan", value: "catatan", $isDisabled: false},
    {label: "ID Pegawai", value: "officerid", $isDisabled: false},
    {label: "Tarikh Bayar", value: "tarikhbayar", $isDisabled: false},
    {label: "ID Pejabat", value: "pejabatid", $isDisabled: false},
    {label: "Kod Bank 1", value: "kodbank", $isDisabled: false},
    {label: "Kod Bank 2", value: "kodbankketerangan", $isDisabled: false},
]);
const optionsColumsLabel = (name: {label: string, value: string, $isDisabled: boolean}): string => `${name.label}`;

onMounted(() => {
    getData();
});
const goBack = () :void =>{
    emitToParent("hidePage", true);
}

const getData = (url: string = ""): void =>{
    emitToParent("showLoader");
    let columnValues: string[] = [];
    for(let i=0; i < selected.value.columnsDisplay.length; i++){
        columnValues.push(selected.value.columnsDisplay[i].value);
    }
    let formJson: {
        _token: string,
        pejabat: number | null,
        pegawai: number | null,
        daerah: number | null,
        bentukBayar: number | null,
        bank: number | null,
        colsarg: string[],
        idKodBank: number | null,
        date_start: string| null,
        date_end: string | null,
        min: number | null,
        max: number| null,
        amounAscDesc: string,
        noRujukanBank: string,
        pagePerView: number
    } = {
        _token: data.csrf,
        pejabat: null,
        pegawai: null,
        daerah: null,
        bentukBayar: null,
        bank: null,
        colsarg: columnValues,
        idKodBank: null,
        date_start: null,
        date_end: null,
        min: null,
        max: null,
        amounAscDesc: "",
        noRujukanBank: "",
        pagePerView: selected.value.pagePerView
    };

    if(selected.value.office !== 0){
        formJson.pejabat = selected.value.office;
    }
    if(selected.value.officer !== 0){
        formJson.pegawai = selected.value.officer;
    }
    if(selected.value.district !== 0){
        formJson.daerah = selected.value.district;
    }
    if(selected.value.payType !== 0){
        formJson.bentukBayar = selected.value.payType;
    }
    if(selected.value.bank !== 0){
        formJson.bank = selected.value.bank;
    }
    if(selected.value.start !== null){
        formJson.date_start = selected.value.start;
    }
    if(selected.value.end !== null){
        formJson.date_end = selected.value.end;
    }
    if(selected.value.min !== null){
        formJson.min = selected.value.min;
    }
    if(selected.value.max !== null){
        formJson.max = selected.value.max;
    }
    if(selected.value.amounAscDesc !== ""){
        formJson.amounAscDesc = selected.value.amounAscDesc;
    }
    if(selected.value.noRujukanBank !== ""){
        formJson.noRujukanBank = selected.value.noRujukanBank;
    }
    if(selected.value.kodBank !== null){
        formJson.idKodBank = selected.value.kodBank.id;
    }
    axios({
        method: "post",
        url: (url !== "" && url !== typeof Event)? url : data.uri_get_transactions,
        data: formJson,
        headers: {"Content-Type": "application/json"}
    }).then(function (response) {
        isStarting.value = false;
        sumAmountCurrrentPage.value = 0;
        officeList.value = response.data.kpej;
        bankList.value = response.data.bank;
        officerList.value = response.data.kpeg;
        distictList.value = response.data.district;
        paymentType.value = response.data.pmethod;
        payerList.value = response.data.pewakaf.data;
        paginator.value = response.data.pewakaf;
        grandSum.value = response.data.grandSum
        setSumCurrentPage();
        emitToParent("hideLoader");
    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk cari." + error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}

const getKodBank = (bankID: number): void => {
    if (!selected.value.displayKodBank){
        emitToParent("showLoader");
        selected.value.isDisabledKodBank = true;
        kodBank.value = [];
        axios.post(data.uri_kodbank, {
            csrf: data.csrf,
            id: bankID,
        }, ).then((function (data) {
            kodBank.value = data.data;
            if(kodBank.value.length > 0){
                selected.value.isDisabledKodBank = false;
            }
            emitToParent("hideLoader");
        })).catch(function (error) {
            emitToParent("hideLoader");
            Swal.fire({
                icon: "error",
                title: "Ralat berlaku",
                text: "Sila cuba semula pilih bank. " + error,
                timer: 5000,
                timerProgressBar: true,
                confirmButtonColor: "#0d6efd",
                confirmButtonText: "Ok",
            })
        })
    }

}
function displayPewakafInfo(id: number, name: string, district: number): void {
    const jsonReq: {
        csrf: string,
        id: number
    } = {
        csrf: data.csrf,
        id: id,
    }
    axios({
        method: "post",
        url: data.uri_get_modal,
        data: JSON.stringify(jsonReq),
        headers: {"Content-Type": "application/json"}
    }).then(function (response) {
        const transactionDataa:{
            jenisWakaf : string,
            daerah : number,
            namaProjek : string,
            unit : number,
            jenisPemilikan : string,
            pemilikWakaf : string,
        }[] = [];
        for(let i=0; i < response.data[0].length; i++){
            transactionDataa.push({
                jenisWakaf : response.data[0][i].jenisWakaf,
                daerah : response.data[0][i].daerah,
                namaProjek : response.data[0][i].namaProjek,
                unit : response.data[0][i].unit,
                jenisPemilikan : response.data[0][i].jenisPemilikan,
                pemilikWakaf : response.data[0][i].pemilikWakaf,
            });
        }
        const modalData : {
            nama: string,
            daerah: number,
            printLink: string,
            transaction: {
                jenisWakaf : string,
                daerah : number,
                namaProjek : string,
                unit : number,
                jenisPemilikan : string,
                pemilikWakaf : string,
            }[]
        } = {
            nama: name,
            daerah: district,
            printLink: response.data[1].uri,
            transaction: transactionDataa,
        };
        emitToParent("showModal", modalData);
    }).catch(function (error) {
        console.log(error )
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk cari",
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}

const setSumCurrentPage = () : void =>{
    for(let i=0; i < payerList.value!.length; i++){
        sumAmountCurrrentPage.value += payerList.value![i].GrandSum;
    }
}

const excelDownloadColumnDisplay = () : string =>{
    let str: string =""; //= "["
    for(let i=0; i < selected.value.columnsDisplay!.length; i++){
        //str += "'";
        str += selected.value.columnsDisplay[i].value;
        //str += "'";
        if(i < selected.value.columnsDisplay.length-1){
            str += ",";
        }

    }
    //str += "]";
    return str;
    // return "['a','b']";
}

const resetSearch = (): void =>{
    selected.value.office = 0;
    selected.value.officer = 0;
    selected.value.district = 0;
    selected.value.payType = 0;
    selected.value.bank = 0;
    selected.value.kodBank = null;
    selected.value.displayKodBank = false;
    selected.value.start = null;
    selected.value.end = null;
    selected.value.min = null;
    selected.value.max = null;
    selected.value.amounAscDesc = "";
    selected.value.noRujukanBank = "";
    selected.value.pagePerView = 15;
    getData();
}
const changeSort = (orderBy: string): void =>{
    selected.value.amounAscDesc = orderBy;
}

defineExpose({
    isCloseLoader
})
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>
